<template>
  <div id="certificationEdit">
    <div class="page_bd page_bd_spacing m-b-md">
      <div class="certification_step">
        <div class="weui-flex">
          <div class="weui-flex__item">
            <i class="active"></i>
            <div class="placeholder">身份证信息提交</div>
          </div>
          <div class="weui-flex__item">
            <i></i>
            <div class="placeholder">认证完成</div>
          </div>
        </div>
      </div>
    </div>
    <div class="page_bd page_bd_spacing">
      <div class="weui-cells__title">填写身份证信息</div>
      <div class="weui-cells weui-cells_form">
        <div class="weui-cell">
          <div class="weui-cell__hd"><label class="weui-label">姓名</label></div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" placeholder="请输入您的真实姓名" v-model="realName"/>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd"><label class="weui-label">身份证</label></div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" maxlength="18" placeholder="请输入您的身份证号" v-model="idCard"/>
          </div>
        </div>
        <div class="button-sp-area">
          <a href="javascript:;" class="weui-btn weui-btn_block btn-certification" @click="submit">提交认证</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'certificationEdit',
  data () {
    return {
      realName: '', // 真实姓名
      idCard: '', // 身份证
      submitFlag: true
    }
  },
  methods: {
    submit () { // 提交认证
      let self = this
      if (!self.realName) {
        self.$weui.toast('请输入您的真实姓名', {
          duration: 2000,
          className: 'toast_text'
        })
        return
      }
      if (!self.idCard) {
        self.$weui.toast('请输入您的身份证号', {
          duration: 2000,
          className: 'toast_text'
        })
        return
      }
      if (self.submitFlag) {
        self.submitFlag = false
        self.$fly
          .request({
            method: 'post',
            url: '/h5/star/alliance2/star/guest/account/real',
            params: {
              realName: self.realName,
              cardNo: self.idCard
            }
          })
          .then(res => {
            self.submitFlag = true
            if (res.success) {
              self.$router.push('certificationSuccess')
            }
          })
          .catch(err => {
            self.submitFlag = true
            console.log(err)
          })
      }
    }
  },
  activated () { },
  mounted () { }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
#certificationEdit{
  .m-b-md{
    margin-bottom: 15px;
  }
  .certification_step{
    width: 405px;
    padding: 95px 15px 50px;
    background-color: #fff;
    text-align: center;
    margin: 0 auto;
    .weui-flex{
      position: relative;
      .weui-flex__item{
        position: absolute;
        width: 22px;
        z-index: 2;
      }
      i{
        display: block;
        width: 14px;
        height: 14px;
        border: solid 8px #ccc;
        background-color: #ccc;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
      }
      i.active{
        border-color: #f26d06;
        background-color: #fff;
      }
      .weui-flex__item:nth-child(1){
        left: 0;
      }
      .weui-flex__item:nth-child(2){
        right: 0;
      }
      &:after{
        content: ' ';
        position: absolute;
        left: 0;
        top: 11px;
        display: block;
        width: 100%;
        height: 4px;
        background-color: #ccc;
      }
      .placeholder{
        position: absolute;
        left: 50%;
        top: -48px;
        width: 300px;
        margin-left: -150px;
        font-size: 26px;
        color: #333;
      }
    }
  }
  .page_bd {
    padding: 20px 15px;
    background-color: #fff;
  }
  .weui-cells__title{
    line-height: 66px;
    color: #666;
    font-size: 26px;
    margin: 0;
  }
  .button-sp-area{
    padding-top: 70px;
    border-top: 1px solid rgba(0, 0, 0, 0.1)
  }
  .btn-certification{
    background-color: #fb4e2d;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mine/certification/edit.vue